import { useState } from 'react'
import '@amigo/ui/brand.css'
import './landing.css'

export function App() {
  const [stampsCount, setStampsCount] = useState<number>(4)
  const [isAnnual, setIsAnnual] = useState<boolean>(true)
  const [openFaq, setOpenFaq] = useState<number | null>(0)
  const [isDemoModalOpen, setIsDemoModalOpen] = useState<boolean>(false)
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null)

  const handleAddStamp = () => {
    setStampsCount((prev) => (prev >= 10 ? 1 : prev + 1))
  }

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index)
  }

  const handleSelectPlan = (planName: string) => {
    setSelectedPlan(planName)
    setIsDemoModalOpen(true)
  }

  return (
    <div className="landing-root">
      {/* 1. Header / Navigation */}
      <header className="header">
        <div className="container header-inner">
          <a href="#" className="brand-logo">
            <img src="/brand/logo-horizontal-lima.png" alt="Amigo Card" />
          </a>

          <nav>
            <ul className="nav-menu">
              <li><a href="#como-funciona" className="nav-link">Cómo Funciona</a></li>
              <li><a href="#mecanicas" className="nav-link">Mecánicas</a></li>
              <li><a href="#escaner-pos" className="nav-link">Escáner POS</a></li>
              <li><a href="#precios" className="nav-link">Precios</a></li>
              <li><a href="#preguntas-frecuentes" className="nav-link">FAQs</a></li>
            </ul>
          </nav>

          <a href="#precios" className="btn btn-primary">
            Comenzar Ahora
          </a>
        </div>
      </header>

      {/* 2. Hero Section */}
      <section className="hero">
        <div className="container hero-grid">
          <div className="hero-content">
            <div className="hero-badge">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              Programa de Lealtad Digital
            </div>

            <h1 className="hero-title">
              Hazte el mejor amigo <span className="gradient-text">de tus clientes</span>
            </h1>

            <p className="hero-description">
              Ayudamos a las PYMES de servicios a desarrollar su programa de lealtad, democratizando el acceso a la tecnología. Cero fricción para tus clientes, directo en su celular.
            </p>

            <div className="hero-actions">
              <a href="#precios" className="btn btn-primary">
                Crear Mi Club de Lealtad
              </a>
              <button 
                onClick={() => setIsDemoModalOpen(true)} 
                className="btn btn-secondary"
              >
                Escanear Tarjeta de Prueba
              </button>
            </div>

            <div className="hero-metrics">
              <div className="metric-item">
                <span className="metric-value">Cero Apps</span>
                <span className="metric-label">Para Descargar</span>
              </div>
              <div className="metric-item">
                <span className="metric-value">2 Clics</span>
                <span className="metric-label">Para Agregar a Wallet</span>
              </div>
              <div className="metric-item">
                <span className="metric-value">&lt; 24h</span>
                <span className="metric-label">En línea y Operando</span>
              </div>
            </div>
          </div>

          {/* Phone Mockup Showcase */}
          <div className="mockup-container">
            <div className="phone-glow"></div>
            <div className="phone-frame">
              <div className="phone-notch"></div>
              <div className="wallet-screen">
                <div className="wallet-header">
                  <span>Wallet</span>
                  <div className="wallet-badge">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.84c.66-.8 1.11-1.92.99-3.04-.96.04-2.12.64-2.81 1.44-.61.71-1.15 1.86-1 2.97 1.07.08 2.16-.56 2.82-1.37z"/>
                    </svg>
                    Pase Seguro
                  </div>
                </div>

                {/* Digital Loyalty Pass */}
                <div className="pass-card">
                  <div className="pass-header">
                    <div className="pass-merchant">
                      <div className="merchant-logo">☕</div>
                      <div>
                        <div className="merchant-name">Café Barrio</div>
                        <div className="merchant-subtext">Tu tarjeta de lealtad</div>
                      </div>
                    </div>
                  </div>

                  <div className="pass-stamps">
                    {Array.from({ length: 10 }).map((_, i) => (
                      <div 
                        key={i} 
                        className={`stamp-dot ${i < stampsCount ? 'active' : ''}`}
                      >
                        {i < stampsCount ? '☕' : i + 1}
                      </div>
                    ))}
                  </div>

                  <div className="pass-reward-info">
                    <span>Recompensa: <strong>Café Gratis (10/10)</strong></span>
                    <span>{stampsCount}/10 Sellos</span>
                  </div>

                  <div className="pass-barcode">
                    <div className="barcode-lines"></div>
                    <span className="barcode-number">AMIGO-8829-3041</span>
                  </div>
                </div>

                {/* Interactive Simulator Controller */}
                <div className="interactive-counter">
                  <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                    Prueba simulador:
                  </span>
                  <button onClick={handleAddStamp} className="counter-btn">
                    + Añadir Sello
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. How It Works (4-Step Flow) */}
      <section id="como-funciona" className="section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Cercano e Innovador</span>
            <h2 className="section-title">¿Cómo funciona Amigo Card?</h2>
            <p className="section-subtitle">
              Pasa de cero a tener tu propio club de lealtad en Apple y Google Wallet en menos de 24 horas.
            </p>
          </div>

          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">01</div>
              <h3 className="step-title">Diseña tu Tarjeta</h3>
              <p className="step-text">
                Personaliza los colores de tu marca, logo y define las reglas de recompensas (ej. Compra 9 cafés, recibe el 10° gratis).
              </p>
            </div>

            <div className="step-card">
              <div className="step-number">02</div>
              <h3 className="step-title">Coloca tu QR</h3>
              <p className="step-text">
                Coloca tu código QR exclusivo en tu mostrador. Tus clientes lo escanean y agregan el pase a su Wallet en 2 clics.
              </p>
            </div>

            <div className="step-card">
              <div className="step-number">03</div>
              <h3 className="step-title">Valida en Mostrador</h3>
              <p className="step-text">
                Tus cajeros usan nuestro escáner web en cualquier celular para agregar sellos en 1 segundo sin integraciones complejas.
              </p>
            </div>

            <div className="step-card">
              <div className="step-number">04</div>
              <h3 className="step-title">Fideliza y Crece</h3>
              <p className="step-text">
                Usa la data de tus clientes para mejorar la retención y envíales notificaciones automáticas para que regresen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 4. Loyalty Mechanics & Feature Grid */}
      <section id="mecanicas" className="section" style={{ background: 'color-mix(in srgb, var(--ac-noche) 40%, transparent)' }}>
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Democratizando la Lealtad</span>
            <h2 className="section-title">Mecánicas de lealtad para tu PYME</h2>
            <p className="section-subtitle">
              Soluciones para cafeterías, restaurantes, talleres, estéticas y más.
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🏷️</div>
              <h3 className="feature-title">Tarjetas de Sellos Digitales</h3>
              <p className="feature-text">
                Reemplaza las tarjetas de cartón que se pierden o rompen. Sellos dinámicos en la billetera nativa del smartphone.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">💎</div>
              <h3 className="feature-title">Puntos Acumulables</h3>
              <p className="feature-text">
                Tus clientes acumulan puntos por consumo que pueden canjear por productos o descuentos en su próxima visita.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">💵</div>
              <h3 className="feature-title">Cashback y Saldo</h3>
              <p className="feature-text">
                Otorga saldo en monedero digital como recompensa por la lealtad, fomentando el regreso de tus mejores clientes.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📍</div>
              <h3 className="feature-title">Geofencing & Alertas</h3>
              <p className="feature-text">
                El pase interactúa en la pantalla de bloqueo de tu cliente cuando camina cerca de tu negocio (disponible próximamente).
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h3 className="feature-title">Notificaciones Push</h3>
              <p className="feature-text">
                Envía mensajes directos a la pantalla de tus clientes: felicitaciones de cumpleaños o promociones temporales.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3 className="feature-title">Data e Insights</h3>
              <p className="feature-text">
                Conoce a tu cliente. Analiza el volumen de retención y la frecuencia de visitas para tomar mejores decisiones.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Merchant Operations / POS Web Scanner */}
      <section id="escaner-pos" className="section">
        <div className="container">
          <div className="scanner-banner">
            <div className="scanner-info">
              <div className="scanner-badge">100% Independiente</div>
              <h2 className="scanner-title">Escáner Web: Operación rápida sin integraciones</h2>
              <p className="scanner-text">
                Tus cajeros y meseros no necesitan descargar nada de App Store ni Google Play. Acceden desde cualquier navegador web en su teléfono o tablet, sin conectarse a tu software de punto de venta.
              </p>
              <ul className="scanner-list">
                <li className="scanner-item">
                  <span className="check-icon">✓</span>
                  Escaneo instantáneo por cámara en 1 segundo
                </li>
                <li className="scanner-item">
                  <span className="check-icon">✓</span>
                  Cero fricción en el mostrador para sumar recompensas
                </li>
                <li className="scanner-item">
                  <span className="check-icon">✓</span>
                  Sistema híbrido: Próximamente validación por tecnología NFC
                </li>
              </ul>
            </div>

            <div className="scanner-preview-card">
              <div className="scanner-viewfinder">
                <div className="scan-laser"></div>
                <div style={{ fontSize: '2.5rem' }}>📱</div>
              </div>
              <div style={{ color: 'var(--text-primary)', fontWeight: 600, fontSize: '0.95rem' }}>
                POS Web Scanner Activo
              </div>
              <span style={{ color: 'var(--accent-primary)', fontSize: '0.85rem', marginTop: '4px' }}>
                ● Listo para escanear tarjeta
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* 6. Pricing Matrix */}
      <section id="precios" className="section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Planes y Precios</span>
            <h2 className="section-title">Encuentra el plan ideal para tu negocio</h2>
            <p className="section-subtitle">
              Suscripciones accesibles con descuento especial en planes anuales.
            </p>
          </div>

          {/* Monthly / Annual Toggle Switch */}
          <div className="pricing-toggle-container">
            <span className={`toggle-label ${!isAnnual ? 'active' : ''}`}>Pago Mensual</span>
            <div 
              className={`toggle-switch ${isAnnual ? 'active' : ''}`}
              onClick={() => setIsAnnual(!isAnnual)}
            >
              <div className="toggle-circle"></div>
            </div>
            <span className={`toggle-label ${isAnnual ? 'active' : ''}`}>Pago Anual</span>
            <span className="discount-badge">Descuento Early Bird</span>
          </div>

          <div className="pricing-grid">
            {/* Plan 1: Starter */}
            <div className="pricing-card">
              <h3 className="plan-name">Básico</h3>
              <p className="plan-desc">Ideal para cafeterías y estéticas de una sola ubicación.</p>
              <div className="plan-price-container">
                <span className="plan-currency">MXN</span>
                <span className="plan-price">A medida</span>
              </div>
              <ul className="plan-features">
                <li className="feature-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                  1 Sucursal activa
                </li>
                <li className="feature-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                  Tarjetas de sellos digitales
                </li>
                <li className="feature-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                  Escáner Web ilimitado
                </li>
              </ul>
              <button 
                onClick={() => handleSelectPlan('Básico')}
                className="btn btn-secondary" 
                style={{ width: '100%' }}
              >
                Agendar Demo
              </button>
            </div>

            {/* Plan 2: Growth (Popular) */}
            <div className="pricing-card popular">
              <div className="popular-tag">MÁS POPULAR</div>
              <h3 className="plan-name">Crecimiento</h3>
              <p className="plan-desc">Para negocios consolidados que buscan acelerar la retención.</p>
              <div className="plan-price-container">
                <span className="plan-currency">MXN</span>
                <span className="plan-price">A medida</span>
              </div>
              <ul className="plan-features">
                <li className="feature-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                  Múltiples sucursales
                </li>
                <li className="feature-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                  Puntos y Cashback
                </li>
                <li className="feature-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                  Notificaciones Push
                </li>
                <li className="feature-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                  Soporte WhatsApp
                </li>
              </ul>
              <button 
                onClick={() => handleSelectPlan('Crecimiento')}
                className="btn btn-primary" 
                style={{ width: '100%' }}
              >
                Agendar Demo
              </button>
            </div>

            {/* Plan 3: Enterprise */}
            <div className="pricing-card">
              <h3 className="plan-name">A la Medida</h3>
              <p className="plan-desc">Cadenas, franquicias y grandes corporativos.</p>
              <div className="plan-price-container">
                <span className="plan-currency">MXN</span>
                <span className="plan-price">Cotizar</span>
              </div>
              <ul className="plan-features">
                <li className="feature-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                  Tailor-made y ajustes de precios
                </li>
                <li className="feature-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                  Data e Insights avanzados
                </li>
                <li className="feature-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                  Asesor de cuenta dedicado
                </li>
              </ul>
              <button 
                onClick={() => handleSelectPlan('A la Medida')}
                className="btn btn-secondary" 
                style={{ width: '100%' }}
              >
                Contactar Ventas
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 7. Interactive FAQ Accordion */}
      <section id="preguntas-frecuentes" className="section" style={{ background: 'color-mix(in srgb, var(--ac-noche) 40%, transparent)' }}>
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Dudas Frecuentes</span>
            <h2 className="section-title">Preguntas Frecuentes</h2>
            <p className="section-subtitle">
              Resolvemos tus dudas operativas para lanzar con éxito.
            </p>
          </div>

          <div className="faq-container">
            <div className={`faq-item ${openFaq === 0 ? 'open' : ''}`}>
              <button className="faq-question" onClick={() => toggleFaq(0)}>
                <span>¿El cliente final tiene que descargar alguna aplicación?</span>
                <svg className="faq-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M6 9l6 6 6-6"/></svg>
              </button>
              {openFaq === 0 && (
                <div className="faq-answer">
                  <strong>No, en absoluto.</strong> La mayor ventaja de Amigo Card es que la tarjeta digital vive directamente en Apple Wallet o Google Wallet. El cliente solo escanea el QR de tu negocio y la guarda en 2 clics.
                </div>
              )}
            </div>

            <div className={`faq-item ${openFaq === 1 ? 'open' : ''}`}>
              <button className="faq-question" onClick={() => toggleFaq(1)}>
                <span>¿Necesito integrarlo con mi punto de venta (TPV)?</span>
                <svg className="faq-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M6 9l6 6 6-6"/></svg>
              </button>
              {openFaq === 1 && (
                <div className="faq-answer">
                  <strong>No requiere integración.</strong> Operamos 100% independientes. Nuestro escáner web funciona desde el navegador web de cualquier teléfono celular o tablet conectada a internet. Tus cajeros pueden usarlo para sumar sellos al instante.
                </div>
              )}
            </div>

            <div className={`faq-item ${openFaq === 2 ? 'open' : ''}`}>
              <button className="faq-question" onClick={() => toggleFaq(2)}>
                <span>¿En cuánto tiempo puedo estar operando mi club de lealtad?</span>
                <svg className="faq-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M6 9l6 6 6-6"/></svg>
              </button>
              {openFaq === 2 && (
                <div className="faq-answer">
                  El registro y lanzamiento es <strong>instantáneo</strong>. Una vez configurado el diseño de tu tarjeta, te entregamos tu código QR listo para imprimir y el acceso a tu escáner web.
                </div>
              )}
            </div>
            
            <div className={`faq-item ${openFaq === 3 ? 'open' : ''}`}>
              <button className="faq-question" onClick={() => toggleFaq(3)}>
                <span>¿Ofrecen periodo de prueba gratuito?</span>
                <svg className="faq-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M6 9l6 6 6-6"/></svg>
              </button>
              {openFaq === 3 && (
                <div className="faq-answer">
                  No ofrecemos prueba gratuita por el momento, pero puedes solicitar una <strong>demo en vivo</strong> y contactar a nuestro equipo para obtener un descuento por pago anual o "early bird".
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* 8. Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div>
              <a href="#" className="brand-logo">
                <img src="/brand/logo-horizontal-lima.png" alt="Amigo Card" />
              </a>
              <p className="footer-brand-desc">
                Democratizando y descentralizando los programas de lealtad digitales en México y Latinoamérica.
              </p>
            </div>

            <div>
              <h4 className="footer-title">Producto</h4>
              <ul className="footer-links">
                <li><a href="#como-funciona" className="footer-link">Cómo Funciona</a></li>
                <li><a href="#mecanicas" className="footer-link">Mecánicas de Lealtad</a></li>
                <li><a href="#escaner-pos" className="footer-link">Escáner Web</a></li>
                <li><a href="#precios" className="footer-link">Planes y Precios</a></li>
              </ul>
            </div>

            <div>
              <h4 className="footer-title">Contacto</h4>
              <ul className="footer-links">
                <li><a href="#" className="footer-link">WhatsApp de Soporte</a></li>
                <li><a href="#" className="footer-link">Redes Sociales</a></li>
                <li><a href="#" className="footer-link">Agendar Demo</a></li>
              </ul>
            </div>

            <div>
              <h4 className="footer-title">Legal</h4>
              <ul className="footer-links">
                <li><a href="#" className="footer-link">Términos y Condiciones</a></li>
                <li><a href="#" className="footer-link">Aviso de Privacidad</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <span>&copy; 2026 Amigo Card. Todos los derechos reservados.</span>
            <span>Infraestructura técnica provista por <strong>Sendash</strong></span>
          </div>
        </div>
      </footer>

      {/* Interactive Demo / Plan Selection Modal */}
      {isDemoModalOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.8)',
          backdropFilter: 'blur(8px)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            background: 'var(--bg-card)',
            border: '1px solid var(--border-hover)',
            borderRadius: 'var(--radius-xl)',
            padding: '36px',
            maxWidth: '500px',
            width: '100%',
            position: 'relative',
            boxShadow: 'var(--shadow-card)'
          }}>
            <button 
              onClick={() => setIsDemoModalOpen(false)}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: 'none',
                border: 'none',
                color: 'var(--text-muted)',
                fontSize: '1.5rem',
                cursor: 'pointer'
              }}
            >
              &times;
            </button>

            <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.75rem', marginBottom: '12px' }}>
              {selectedPlan ? `Agendar Demo: Plan ${selectedPlan}` : 'Prueba Amigo Card en Vivo'}
            </h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', marginBottom: '24px' }}>
              {selectedPlan 
                ? 'Ingresa tus datos y un asesor te contactará por WhatsApp para tu demostración.' 
                : 'Escanea este QR con tu iPhone o Android para ver cómo luce la tarjeta digital en tu Wallet:'}
            </p>

            {!selectedPlan && (
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '16px',
                width: '180px',
                height: '180px',
                margin: '0 auto 24px auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '2px solid var(--accent-primary)'
              }}>
                {/* SVG QR Code Simulation */}
                <svg width="140" height="140" viewBox="0 0 100 100" fill="none">
                  <rect width="100" height="100" fill="white"/>
                  <path d="M0 0h30v30H0zM10 10h10v10H10zM70 0h30v30H70zM80 10h10v10H80zM0 70h30v30H0zM10 80h10v10H10z" fill="black"/>
                  <rect x="40" y="40" width="20" height="20" fill="var(--bg-card)"/>
                  <path d="M40 0h20v20H40zM0 40h20v20H0zM80 40h20v20H80zM40 80h20v20H40zM70 70h10v10H70zM90 70h10v10H90zM70 90h30v10H70z" fill="black"/>
                </svg>
              </div>
            )}

            <form onSubmit={(e) => {
              e.preventDefault()
              alert('¡Gracias! Nos pondremos en contacto pronto.')
              setIsDemoModalOpen(false)
            }} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <input 
                type="text" 
                placeholder="Nombre de tu Negocio" 
                required
                style={{
                  padding: '12px 16px',
                  borderRadius: '10px',
                  background: 'rgba(247, 247, 247, 0.05)',
                  border: '1px solid var(--border-color)',
                  color: 'white',
                  fontSize: '0.95rem'
                }}
              />
              <input 
                type="text" 
                placeholder="Teléfono / WhatsApp" 
                required
                style={{
                  padding: '12px 16px',
                  borderRadius: '10px',
                  background: 'rgba(247, 247, 247, 0.05)',
                  border: '1px solid var(--border-color)',
                  color: 'white',
                  fontSize: '0.95rem'
                }}
              />
              <button type="submit" className="btn btn-primary" style={{ width: '100%', marginTop: '8px' }}>
                {selectedPlan ? 'Solicitar Demo' : 'Probar Tarjeta'}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
